import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { DemonstracaoService } from 'src/app/core/services/demonstracao.service';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-teste-jornadas-digitais',
  templateUrl: './teste-jornadas-digitais.component.html',
  styleUrls: ['./teste-jornadas-digitais.component.scss']
})

export class TesteJornadasDigitaisComponent implements OnInit {
  data;
  pagina = 1;
  isValid = false;
  imagemSelecionada = 0;
  formGroup: FormGroup;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private demonstracaoService: DemonstracaoService,
    private modalService: NgbModal,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('TESTE_JORNADAS_DIGITAIS').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
      this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
      this.gaService.pageView(this.router.url);
    });
  }

  recebeValidacao(isValid) {
    this.isValid = isValid;
  }

  recebeImagemSelecionada(imagemSelecionada) {
    this.imagemSelecionada = imagemSelecionada;
  }

  recebeDados(formGroup) {
    this.formGroup = formGroup;
  }

  voltarNavegacao() {
    this.pagina--;
  }

  avancarNavegacao() {
    if (this.pagina === 2) {
      this.demonstracaoService.enviarEmail(
        this.imagemSelecionada,
        this.formGroup.get('formNome').value,
        this.formGroup.get('formEmail').value,
        this.formGroup.get('formTelefone').value,
        this.formGroup.get('formNomeEmpresa').value,
        this.formGroup.get('formCargo').value
      )
        .subscribe(
          res => {
            this.pagina = 3;
          },
          err => {
            this.pagina = 2;
            this.isValid = false;
            if (err != null) {
              if (err.error != null) {
                const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                modalRef.componentInstance.message = err.error;
              }
            }
          }
        )
    } else {
      this.pagina++;
      this.isValid = false;
    }
  }

}
